import { render, staticRenderFns } from "./BootstrapModal.vue?vue&type=template&id=dc13b8b6&scoped=true&"
import script from "./BootstrapModal.vue?vue&type=script&lang=js&"
export * from "./BootstrapModal.vue?vue&type=script&lang=js&"
import style0 from "./BootstrapModal.vue?vue&type=style&index=0&id=dc13b8b6&prod&lang=css&"
import style1 from "./BootstrapModal.vue?vue&type=style&index=1&id=dc13b8b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc13b8b6",
  null
  
)

export default component.exports